export default __webpack_public_path__ + "static/media/gy.d21e0a62.png";